import { render, staticRenderFns } from "./COATransaction.vue?vue&type=template&id=0addbd56"
import script from "./COATransaction.vue?vue&type=script&lang=js"
export * from "./COATransaction.vue?vue&type=script&lang=js"
import style0 from "./COATransaction.vue?vue&type=style&index=0&id=0addbd56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports